<template>
  <v-container>
      <v-layout row wrap>
          <v-flex>
              <v-card flat>
                    <v-card-title>
                        <v-icon style="color:red;font-size:46px;">warning</v-icon><h2 class="pl-3">Error</h2>
                    </v-card-title>
                    <div style="border-bottom:solid 2px #c53535;" class="ml-2 mr-2"></div>
                  <v-card-text>{{errorMessage}}</v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
      <v-layout row wrap>
          <v-flex>
              
          </v-flex>
      </v-layout>      
  </v-container>
</template>

<script>
export default {
    props:["errorMessage"]
}
</script>

<style>

</style>